/**
 * Do not edit this file it is auto-generated by io-utils / gen-api-models.
 * See https://github.com/pagopa/io-utils
 */
/* eslint-disable  */

import { PaymentType } from "./PaymentType";
import * as t from "io-ts";

// required attributes
const PaymentTypesR = t.interface({
  payment_types: t.readonlyArray(PaymentType, "array of PaymentType")
});

// optional attributes
const PaymentTypesO = t.partial({});

export const PaymentTypes = t.intersection(
  [PaymentTypesR, PaymentTypesO],
  "PaymentTypes"
);

export type PaymentTypes = t.TypeOf<typeof PaymentTypes>;
